<template>
  <div id="app">
    <b-navbar toggleable="lg" type="dark" variant="dark">
      <b-navbar-brand href="#/">{{title0}}</b-navbar-brand>
      <b-navbar-toggle target="nav_collapse" />
      <b-collapse is-nav id="nav_collapse">
        <b-navbar-nav>
          <b-nav-item href="#/">
            <font color="white" size="4" style="padding-top:1px;">{{title}}</font>
          </b-nav-item>
          <!-- <b-nav-item @click="setTH">ไทย</b-nav-item>
          <b-nav-item @click="setENG">ENG</b-nav-item>-->
        </b-navbar-nav>
        <b-navbar-nav class="ml-auto"></b-navbar-nav>
      </b-collapse>
    </b-navbar>
    <b-container fluid>
      <b-alert
        :show="dismissCountDown"
        dismissible
        :variant="msgtype"
        @dismissed="dismissCountDown=0"
        @dismiss-count-down="countDownChanged"
      >{{msgAlert}}</b-alert>
      <!-- <div class="text-center">
        <b-button style="margin-left:10px;" variant="primary" size="sm" @click="setTH">ไทย</b-button>
        <b-button style="margin-left:10px;" variant="primary" size="sm" @click="setENG">ENG</b-button>
      </div>-->
      <b-container fluid>
        <router-view />
      </b-container>
    </b-container>
  </div>
</template>

<script>
export default {
  name: "App",
  data: function() {
    return {
      msgtype: "danger",
      msgAlert: "",
      dismissSecs: 2,
      dismissCountDown: 0,
      title0: "Board Game Everyday Cafe",
      title: ""
    };
  },
  mounted() {
    this.$store.watch(this.$store.getters.getLG, language => {
      if (language == "TH") {
        this.title0 = "Board Game Everyday Cafe";
        this.title = "";
      } else if (language == "ENG") {
        this.title0 = "Board Game Everyday Cafe";
        this.title = "";
      }
    });
  },
  methods: {
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    showAlert(msg, type) {
      this.msgtype = type == null ? "danger" : type;
      this.msgAlert = msg;
      this.dismissCountDown = this.dismissSecs;
      window.scrollTo(0, 0);
    },
    setTH() {
      this.$store.state.language = "TH";
      // this.showAlert("เปลี่ยนเป็นภาษาไทย", "success");
    },
    setENG() {
      this.$store.state.language = "ENG";
      // this.showAlert("Change language to English", "success");
    }
  }
};
</script>
